export enum SAWAskForUsername {
	NOASK = 'no-ask',
	ONSUMBIT = 'on-submit',
}
